import { render, staticRenderFns } from "./OpenAPI.vue?vue&type=template&id=e8532ade&"
import script from "./OpenAPI.vue?vue&type=script&lang=js&"
export * from "./OpenAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports